import { useSelector } from "react-redux";
import { getGlobalLoadingOverlayState } from "../redux/slices/global-loading-overlay-slice";
import LoadingOverlay from "./loading-overlay";

const GlobalLoadingOverlay = () => {
  const { show, message } = useSelector(getGlobalLoadingOverlayState);

  return (
    <LoadingOverlay
      show={show}
      message={message}
      fullScreen={true}
    />
  );
};

export default GlobalLoadingOverlay;